'use strict';

var React = require('react');

var SvgSoundMajor = function SvgSoundMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.548 2.892a1 1 0 1 1 .904-1.784c3.303 1.674 5.378 5.05 5.378 8.892 0 3.832-2.08 7.212-5.376 8.891a1 1 0 1 1-.908-1.782c2.628-1.338 4.284-4.03 4.284-7.109 0-3.087-1.651-5.774-4.282-7.108zm-1.214 4.154a1 1 0 1 1 1.332-1.492c1.284 1.146 2.007 2.714 2.007 4.446 0 1.733-.723 3.3-2.007 4.446a1 1 0 1 1-1.332-1.492c.865-.771 1.339-1.8 1.339-2.954 0-1.154-.474-2.182-1.339-2.954zm-10.835 6.955a1.5 1.5 0 0 1-1.499-1.501v-5a1.5 1.5 0 0 1 1.5-1.5h2.15l4.725-3.78a1 1 0 0 1 1.625.78v14a1 1 0 0 1-1.625.781l-4.726-3.78h-2.149z"
  }));
};

exports.SvgSoundMajor = SvgSoundMajor;
